declare global {
  interface Window {
    overrides_data: Record<string, unknown>;
  }
}

window.overrides_data = window.overrides_data || {};

export {};
